import React from 'react';
import { Field, getIn, FormikState } from 'formik';

import { PASCProps } from '@buyside/components/presentation/UserApplication/Pages/proApplicationSubmission/ProApplicationSubmissionContainer';
import { WizardSubmitButton } from '@buyside/components/presentation/Form/Wizard/Wizard';
import {
  buysideDisclaimer,
  allocatorDisclaimer,
  retailDisclaimer
} from '../../Helpers/userApplicationPageConstants';
import PageHeader from '../../Helpers/pageHeader';
import PageFooter from '../../Helpers/PageFooter';
import RecaptchaFailed from '../../Helpers/RecaptchaFailed';

import { termsOfUseUrl, privacyPolicyUrl } from '@buyside/util/urlHelper';

import {
  InvestorTypes,
  ApplicantTypes,
  ApplicationFormValues
} from '@interfaces/userApplication/userApplication';

import styles from '../pageStyles.scss';

export type PASProps = Pick<FormikState<ApplicationFormValues>, 'errors' | 'touched' | 'values'> &
  PASCProps;

const ProApplicationSubmission: React.FunctionComponent<PASProps> = ({
  errors,
  isLoading,
  isRobot,
  touched,
  values
}): React.ReactElement => {
  const { investorType, applicantType } = values;

  const isBasic = applicantType === ApplicantTypes.basic;

  let disclaimer;
  if (isBasic) {
    disclaimer = retailDisclaimer;
  } else {
    disclaimer = investorType === InvestorTypes.allocator ? allocatorDisclaimer : buysideDisclaimer;
  }

  const isTouched = getIn(touched, 'acceptedDisclaimer');
  const error = getIn(errors, 'acceptedDisclaimer');

  return (
    <>
      <PageHeader subHeader={isBasic ? undefined : 'Submit your application'} />
      <div className={styles.inputFormColumn}>
        <label className={styles.checkboxes} data-heap="application-terms-conditions">
          <Field type="checkbox" name="acceptedDisclaimer" disabled={isLoading} />
          {disclaimer}
        </label>
        {isTouched && error && <div className={styles.fieldError}>{error}</div>}
      </div>
      <WizardSubmitButton
        analyticsTag="submit_application"
        isLoading={isLoading}
        submitText="Submit Application"
      />
      {isRobot && <RecaptchaFailed />}
      <div className={styles.footerText}>
        <p>
          By clicking "Submit Application", I agree to SumZero's{' '}
          <a href={termsOfUseUrl()} target="_blank" rel="noopener noreferrer">
            Terms of Use
          </a>{' '}
          and{' '}
          <a href={privacyPolicyUrl()} target="_blank" rel="noopener noreferrer">
            Privacy Policy
          </a>
          .
        </p>
      </div>
      <PageFooter />
    </>
  );
};

export default ProApplicationSubmission;
